
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { groupBy, mapBy } from "./utils.js";

export const BLOG_ABOUT = "B" // Categorie Blog Banner
export const BLOG_LOGO = "L" // Categorie Blog Banner

export const categories = [
    { id: "A", label: "Accueil", hidden: false},
    { id: "P", label: "Programme", hidden: false },
    { id: "H", label: "Hébergement", hidden: false },
    { id: "I", label: "Infos pratiques", hidden: false },
    { id: "C", label: "Contact", hidden: false },
    { id: "LM", label: "Liste de mariage", hidden: false },
    { id: "R", label: "Réponse", hidden: false },
    { id: "P", label: "Photos", hidden: true },
    { id: "E", label: "Espace invité", hidden: true },
].filter( (c) => !c.hidden);

export async function count(id) {
    return get(`articles/?wedding_id=${id}&count=true`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return mapBy(d, "category");
        })
        .catch(e => {
            return [];
        });
}

export async function load(id, category, published, pinned, count, nocontent) {

    let query = `articles/?wedding_id=${id}`;
    if (category !== undefined)
        query += `&category=${category}`;
    if (published !== undefined)
        query += `&published=${published}`;
    if (pinned !== undefined)
        query += `&pinned=${pinned}`;
    if (count !== undefined)
        query += `&count=${count}`;
    if (nocontent !== undefined)
        query += '&nocontent=true';

    return get(query, token || DEV_TOKEN)
        .then(r => r.data);
}

export async function loadArticle(id, article_id) {
    return get(`articles/?wedding_id=${id}&id=${article_id}`, token || DEV_TOKEN)
        .then(r => r.data);
}

/**
 * Create.
 */
export function create(id, title, category, ranking, content, published) {
    return post('articles/',
        {
            wedding_id: id,
            title: title,
            ranking: ranking,
            category: category,
            published: published,
            content: content
        }, token || DEV_TOKEN);
}

/**
 * Update.
 */
export function update(id, article_id, title, category, ranking, content, published, pinned, priority) {
    return put('articles/',
        {
            wedding_id: id,
            id: article_id,
            title: title,
            ranking: ranking,
            category: category,
            published: published,
            pinned: pinned,
            priority: priority,
            content: content
        }, token || DEV_TOKEN);
}

export function publish(id, article_id, published) {
    return put('articles/',
        {
            wedding_id: id,
            id: article_id,
            published: published
        }, token || DEV_TOKEN);
}

export function pin(id, article_id, pinned, priority) {
    return put('articles/',
        {
            wedding_id: id,
            id: article_id,
            pinned: pinned,
            priority: priority
        }, token || DEV_TOKEN);
}

/**
 * Delete
 */
export function deleteArticle(id, article_id) {
    return del('articles/',
        {
            wedding_id: id,
            id: article_id
        }, token || DEV_TOKEN);
}

